<template>
  <div>
    <UIFormItem
      :label="t('settings.calendar.one_time_link')"
      :show-label="false"
      :show-feedback="false"
      class="mt-2"
    >
      <UIInput
        id="scheduling-link-input"
        v-model="oneTimeLink"
        class="mr-2 !w-9/12"
        :readonly="true"
        size="medium"
        :disabled="true"
        :placeholder="t('settings.calendar.loading')"
        :loading="isLoading"
      />
      <UIButton
        id="copyOneTimeLinkButton"
        type="primary"
        size="small"
        class="!w-3/12"
        :disabled="isGeneratingLink || data?.isSaving"
        @click="methods.copyOneTimeLink"
      >
        <Copy01Icon class="mr-2 h-4 w-4" /> {{ t('settings.calendar.copy') }}
      </UIButton>
    </UIFormItem>
    <UIButton
      id="regenerateOneTimeLink"
      class="mt-3 p-2 text-blue-700"
      :text="true"
      :disabled="isGeneratingLink || data?.isSaving"
      @click="methods.generateOneTimeLink"
    >
      <RefreshCcw05Icon class="mr-2 h-4 w-4" />
      {{ t('settings.calendar.generate_link') }}
    </UIButton>
    <div class="py-2 text-sm text-gray-500">
      <h2 class="py-2 font-semibold">
        {{ t('settings.calendar.one_time_link') }}
      </h2>
      {{ t('settings.calendar.share_otl') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { Copy01Icon, RefreshCcw05Icon } from '@gohighlevel/ghl-icons/24/outline'
import {
  UIButton,
  UIFormItem,
  UIInput,
  useNotification,
} from '@gohighlevel/ghl-ui'
import { PropType, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { CalendarService } from '../../../class/services/CalendarService'
import AppState from '../../../states/app'
import { ICalendarShare } from '../../../types'
import { copyToClipboard } from '../../../utils/generalFunctions'

const notification = useNotification()
const oneTimeLink = ref('')
const isGeneratingLink = ref(false)
const isLoading = ref(true)
const { t } = useI18n()
const props = defineProps({
  data: {
    type: Object as PropType<ICalendarShare>,
    default: null,
  },
})
onMounted(async () => {
  await methods.generateOneTimeLink()
  isLoading.value = false
})

const methods = {
  async copyOneTimeLink() {
    if (oneTimeLink.value) {
      copyToClipboard(oneTimeLink.value)
      notification.info({
        content: t('settings.calendar.copied_to_clipboard'),
        duration: 1 * 1000,
      })
    }
  },
  async generateOneTimeLink() {
    let temporaryUrl
    isGeneratingLink.value = true
    try {
      if (props.data?.id) {
        temporaryUrl = await CalendarService.generateOneTimeSlug(props.data?.id)
        if (!temporaryUrl?.data?.oneTimeSlug) {
          throw 'Invalid '
        }
        oneTimeLink.value = `${AppState?.baseUrl}/widget/${props.data?.otlPath}/${temporaryUrl?.data?.oneTimeSlug.slugId}?slug=${props.data?.slug}`
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error: one time link fetching', props.data?.id, error)
      notification.error({
        content: t('settings.calendar.generate_link_error'),
        duration: 1 * 1000,
      })
    }
    isGeneratingLink.value = false
  },
}
</script>
